import { Toolbar } from '#components/Toolbar'
import type { ButtonMode } from '#state'

export const ChangeTrackingMenuButton = ({
  mode,
  togglePanel,
}: {
  mode: ButtonMode
  togglePanel: Callback
}) => (
  <Toolbar.Button
    icon="fa-plus-minus"
    label="Changes"
    mode={mode}
    onClick={togglePanel}
  />
)
